import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
} from 'storyblok-rich-text-react-renderer';
import StoryBlokLink from './StoryBlokLink';
import LinkResolver from '../../helpers/link-resolver';
import { getStoryblokAlt } from '../../helpers/common';

function richText(content) {
  if (!content) return null;

  return render(content, {
    markResolvers: { [MARK_LINK]: LinkResolver },
    nodeResolvers: {
      [NODE_PARAGRAPH]: (children) => (
        <p className="first-of-type:mt-0 last-of-type:mb-0">{children}</p>
      ),
    },
  });
}

export function PartnerCategory({ blok }) {
  // Legacy taxonomy block with metadata only.
  return <div {...storyblokEditable(blok)} className="hidden" aria-hidden="true" />;
}

export function SplitPanesStories({ blok }) {
  // Legacy Storyblok component currently without a React implementation.
  return <div {...storyblokEditable(blok)} className="hidden" aria-hidden="true" />;
}

export function ReferenceImplementation({ blok }) {
  return (
    <section {...storyblokEditable(blok)} className="mt-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        {blok?.image?.filename && (
          <img
            src={blok.image.filename}
            alt={getStoryblokAlt(blok.image, blok.title || '')}
            loading="lazy"
            decoding="async"
            className="w-full h-auto object-cover"
          />
        )}
        <div>
          {blok?.title && <h3 className="text-2xl font-bold mb-4">{blok.title}</h3>}
          {blok?.description && (
            <div className="text-sm leading-relaxed">
              {richText(blok.description)}
            </div>
          )}
          {blok?.link && (
            <StoryBlokLink
              link={blok.link}
              className="inline-block mt-4 text-latori-pink font-semibold hover:underline"
            >
              {blok.link_label || 'Learn more'}
            </StoryBlokLink>
          )}
        </div>
      </div>
    </section>
  );
}

export function ImagesSlideshowRow({ blok }) {
  const images = Array.isArray(blok?.images) ? blok.images : [];

  if (!images.length) {
    return <div {...storyblokEditable(blok)} className="hidden" aria-hidden="true" />;
  }

  return (
    <div {...storyblokEditable(blok)} className="overflow-x-auto py-2">
      <div className="flex gap-3 min-w-max">
        {images.map((item) => (
          <img
            key={item?._uid || item?.image?.filename}
            src={item?.image?.filename}
            alt={getStoryblokAlt(item?.image, '')}
            loading="lazy"
            decoding="async"
            className="h-44 w-auto object-contain"
          />
        ))}
      </div>
    </div>
  );
}
